import { render } from "./PantryAddPage.vue?vue&type=template&id=f734a90a&ts=true"
import script from "./PantryAddPage.vue?vue&type=script&lang=ts"
export * from "./PantryAddPage.vue?vue&type=script&lang=ts"

import "./PantryAddPage.vue?vue&type=style&index=0&id=f734a90a&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__